
import { Component } from '@angular/core';


@Component({

    selector: 'invoiceLko-cmp',
    templateUrl: './invoiceLko.component.html',
    
   
  })
export class InvoiceLkoComponent {}


// WEBPACK FOOTER //
// ./src/app/crm/kccLko/invoiceLko/invoiceLko.component.ts